import React from 'react'
import View from '../../../../../../components/pdf/View'
import Text from '../../../../../../components/pdf/Text'
import Separator from '../../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'
import { getNPCellColor } from '../../../_helpers/pdfHelpers'

const AmbientalTable = ({ categorizedReplies }) => {
  return (
    <View>
      <Table width={'100%'} useFontBaseColor style={{ marginTop: '-1px' }}>
        <TableRow useFontBaseColor bgColor={'#e2e2e2'}>
          <TableCol useFontBaseColor colspan="5">
            <Text bold useFontBaseColor align={'center'}>
              FATORES DE RISCOS AMBIENTAIS
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor bgColor={'#e2e2e2'}>
          <TableCol useFontBaseColor>
            <Text bold useFontBaseColor align={'center'}>
              NP
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold useFontBaseColor align={'center'}>
              Fator de Risco identificado
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold useFontBaseColor align={'center'}>
              Setor
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold useFontBaseColor align={'center'}>
              Funções
            </Text>
          </TableCol>
          <TableCol useFontBaseColor width="45%">
            <Text bold useFontBaseColor align={'center'}>
              Sugestões para redução ou eliminação do risco
            </Text>
          </TableCol>
        </TableRow>
        {categorizedReplies?.ambientais?.map(item => {
          return (
            <>
              <TableRow useFontBaseColor>
                <TableCol useFontBaseColor bgColor={getNPCellColor(item.np)}>
                  <Text bold useFontBaseColor align={'center'}>
                    {item.np}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text useFontBaseColor align={'center'}>
                    {item.questionReply}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text useFontBaseColor align={'center'}>
                    {item.department}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text useFontBaseColor align={'center'}>
                    {item.role}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text useFontBaseColor>{item.suggestionReply}</Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
      </Table>
      <Separator weight={10} />
    </View>
  )
}

export default AmbientalTable
